import { DataGrid, DataGridProps, GridColDef } from '@mui/x-data-grid';
import { FC } from 'react';

const StyledDataGrid: FC<DataGridProps> = (props) => {
  const columns: GridColDef[] = props.columns.map((column) => {
    if (column.headerName === 'Action') {
      return {
        ...column,
        sortable: false,
      };
    }
    return column;
  });

  return (
    <DataGrid
      {...props}
      columns={columns}
      sx={{
        border: '1px solid',
        borderColor: 'var(--border)',
        scrollbarColor: 'var(--inactive-border) transparent',
        '& .MuiDataGrid-scrollbar--vertical': {
          '&::-webkit-scrollbar-track': {
            display: 'none',
          },
          scrollbarWidth: 'thin',
        },
        '& .MuiDataGrid-columnHeaders': {
          backgroundColor: 'var(--inactive-btn) !important',
          fontFamily: 'Outfit',
          fontWeight: 500,
          fontSize: '14px',
          color: 'var(--primary-navy)',
          height: '60px',
          position: 'sticky',
          top: 0,
          zIndex: 1,
        },
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        '& .MuiDataGrid-columnHeader': {
          backgroundColor: 'var(--inactive-btn) !important',
          borderBottom: 'none !important',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          borderBottom: 'none !important',
        },
        '& .MuiDataGrid-columnHeader:focus': {
          outline: 'none',
        },
        '&  .MuiDataGrid-columnHeader:focus-within': {
          outline: 'none',
        },
        '& .MuiDataGrid-cell': {
          border: 'none !important',
          fontFamily: 'Outfit',
          fontWeight: 400,
          fontSize: '14px',
          color: 'var(--primary-navy)',
          height: '50px',
        },
        '& .MuiDataGrid-footerContainer': {
          display: 'none',
        },
        '& .MuiDataGrid-root': {
          border: '1px solid',
          borderColor: 'var(--border)',
        },
        '& .MuiDataGrid-cell:focus': {
          outline: 'none',
        },
        '& .MuiDataGrid-cell:focus-within': {
          outline: 'none',
        },
        '& .MuiDataGrid-row:hover': {
          backgroundColor: 'inherit',
        },
        '& .MuiDataGrid-row:focus': {
          backgroundColor: 'inherit',
        },
        '& .MuiDataGrid-row:focus-within': {
          backgroundColor: 'inherit',
        },
        '& .MuiDataGrid-cell:hover': {
          backgroundColor: 'inherit',
        },
        '& .Mui-selected': {
          backgroundColor: 'inherit !important',
        },
        '& .MuiDataGrid-row.Mui-selected': {
          backgroundColor: 'inherit !important',
        },
        '& .MuiDataGrid-cell.Mui-selected': {
          backgroundColor: 'inherit !important',
        },
        '--DataGrid-rowBorderColor': 'transparent',
        '&.MuiDataGrid-container--top [role=row], &.MuiDataGrid-container--bottom [role=row]':
          {
            backgroundColor: 'var(--inactive-btn)',
          },
        '& .MuiDataGrid-row--borderBottom, & .MuiDataGrid-columnHeader, & .MuiDataGrid-row--borderBottom .MuiDataGrid-filler, & .MuiDataGrid-row--borderBottom .MuiDataGrid-scrollbarFiller':
          {
            borderBottom: 'none',
            backgroundColor: 'var(--inactive-btn)',
          },
      }}
    />
  );
};

export default StyledDataGrid;
